// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-box-list[data-v-69f4fed7]{margin-bottom:.8rem}.page-international .subpanel .subpanel-box[data-v-69f4fed7]{padding-top:0}.page-international .subpanel .subpanel-box[data-v-69f4fed7]:before{background:none}.page-international .subpanel[data-v-69f4fed7]{padding:0}.header-oversea th[data-v-69f4fed7]{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
